export class FormQuestionOption {
    id: string;
    name: string;
}